import React from "react";
import {forceImport} from "../../services/IntegrationApi";

import useAuth from "../../routes/login/AuthContext";
import {useSelectedNetworkContext} from "../../contexts/NetworkContext/context";
import {useSnackbar} from "../../hooks/useSnackbar";

import {Button} from "../../UI/Button";

interface ForceImportButtonProps {
    importType: string | null;
}

export const ForceImportButton = ({importType}: ForceImportButtonProps) => {
    const {getAuthToken} = useAuth();
    const {selectedNetworkId} = useSelectedNetworkContext();
    const {showSuccessSnackbar, showErrorSnackbar} = useSnackbar();

    const handleClick = async () => {
        if (importType === null) {
            showErrorSnackbar("No import type selected");
            return;
        }

        await forceImport(selectedNetworkId, importType, await getAuthToken());
        showSuccessSnackbar("Confirming the import has been requested.!");
    };


    return (
        <Button appearance="danger" isDisabled={!selectedNetworkId} onClick={handleClick}>
            Force Import
        </Button>
    );
};
